import { RootState } from "../store/community-finder-redux-store";

export const selectIsAnchorClicked = (state: RootState) => 
    state?.appStatus?.isAnchorClicked;
